var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 5.25L12 13.5L3 5.25","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3 5.25H21V18C21 18.1989 20.921 18.3897 20.7803 18.5303C20.6397 18.671 20.4489 18.75 20.25 18.75H3.75C3.55109 18.75 3.36032 18.671 3.21967 18.5303C3.07902 18.3897 3 18.1989 3 18V5.25Z","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.3638 12L3.23145 18.538","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M20.7687 18.5381L13.6362 12","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Envelope.defaultProps = {"width":"100%","height":"100%","strokeWidth":"2","viewBox":"0 0 24 24","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
